import client from '../base-api';

interface IGetLIst {
  startDate: string, 
  rangeParametar: string, 
  myMeetings: boolean, 
  remoteMeetings: boolean,  
  userId: number,
  locationIds: number[],
  meetingRoomIds: number[]
}


interface ICalendar {
  "title": string
  "isRemote": boolean
  "startDate": string
  "endDate": string
  "locationId": number
  "meetingRoomId": number
  "unemployedIds": number[],
  "coachIds": number[],
  "meetingType": string
}

const serviceURL = '/calendar';

const calendarService = {
  getList(params: IGetLIst): Promise<any> {
    return client.post(serviceURL+'/list', params);
  },
  
  getMeetingCreate(userId: number): Promise<any> {
    return client.get(serviceURL+'/meeting-create');
  },
  getSingleMeeting(meetId: number): Promise<any> {
    return client.get(serviceURL+'/meeting-details/'+meetId);
  },

  getOfficeList(userId: number, searchParams: string): Promise<any> {
    return client.get(serviceURL+'/office-list/'+userId+'/'+searchParams);
  },

  getOfficeData(userId: number): Promise<any> {
    return client.get(serviceURL+'/office-data/'+userId);
  },

  getUserDropdown(): Promise<any> {
    return client.get(serviceURL+'/user-dropdown');
  },

  deleteMeeting(meetingId: number): Promise<any> {
    return client.put(serviceURL+'/meeting-delete/'+meetingId);
  },
  postCalendarMeeting(data:ICalendar): Promise<any> {
    return client.post(serviceURL+'/meeting-submit', data);
  },
  updateCalendarMeeting(data:ICalendar,id:number): Promise<any> {
    return client.put(serviceURL+'/meeting-submit/' + id, data);
  }

};

export default calendarService;
